import { ref } from 'vue'
import usePut from '../../../core/composables/api/usePut'
import type { Dialog } from './useTeamDialogs'
import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { EventKey } from '../../../core/events/event-key'
import { useEventBus } from '@vueuse/core'
import { useSnackStore } from '../../../stores/snack.store'

export const useUpdateDialog = (dialog: Dialog, callback?: () => void) => {
  const { data, mutate, status } = usePut<string, UpdateableDialog>(`dialog/${dialog.id}`)
  const bus = useEventBus(EventKey.dialogUpdated)
  const snackStore = useSnackStore()

  const plannedAt = ref(dialog.plannedAt ? new Date(dialog.plannedAt) : undefined)
  const leadTimeOption = ref(dialog.leadTimeOption ?? DialogLeadTimeOption.OneWeek)
  const leadTimeCustomDate = ref(new Date())

  const update = async () => {
    await mutate({
      plannedAt: plannedAt.value,
      customLeadTimeDate: leadTimeCustomDate.value,
      leadTimeOption: leadTimeOption.value,
    })

    if (status.value == ApiRequestStatus.Success) {
      bus.emit({ dialogId: data.value })
      snackStore.showInfo('Dialog aktualisiert')
      if (callback) {
        callback()
      }
    }
    if (status.value == ApiRequestStatus.Error) {
      snackStore.showInfo('Fehler')
    }
  }

  return {
    plannedAt,
    update,
    leadTimeOption,
    leadTimeCustomDate,
  }
}

interface UpdateableDialog {
  plannedAt?: Date
  customLeadTimeDate?: Date
  leadTimeOption?: DialogLeadTimeOption
}

export enum DialogLeadTimeOption {
  OneWeek = 'one_week',
  TwoWeeks = 'two_weeks',
  ThreeWeeks = 'three_weeks',
  Custom = 'custom',
}
